import { Pipe, PipeTransform } from '@angular/core';

import * as moment from 'moment';

/*
 * Time helper using momentjs
 * Usage:
 *   timestamp | moment:'DD.MM.YYYY'
 * Defaults to 'L' - locale ie. '01/24/2016'
*/
@Pipe({
  name: 'from'
})
export class MomentPipe implements PipeTransform {
  transform(value:number, args:string[]) : any {
    moment.locale('fr');
    let date = moment(value);
    if (date.isValid()) {
      return moment(value).fromNow();
    } else {
      return value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/filters/ago.filter.ts